import { cilCalendar } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import axios from "axios";
import settings from "client.settings.json";
import { Modal } from "components/modal";
import moment from "moment";
import { AttachmentsViewer } from "pages/attachmentsViewer";
import ComposePage from "pages/compose";
import PropTypes from "prop-types";
import { Component } from "react";
import "react-circular-progressbar/dist/styles.css";
import { FiCornerUpLeft, FiCornerUpRight } from "react-icons/fi";
import { connect } from "react-redux";
import { translate } from "reducers/i18n";
import { setAuthenticatorSource, setUser } from "reducers/user";
import Attachment from "./attachment";
import { DownloadAll } from "./download";
import DownloadMessage from "./download/downloadMessage";
import "./message.css";

const defaultDateFormat = "DD-MM-yyyy";
const defaultTimeFormat = "HH:mm";

class Message extends Component {
  constructor(props) {
    super(props);
    this.state = {
      body: null,
      forwardAllowed: false,
      maxMailSize: null,
      message: null,
      replyAttachmentExtentions: [],
      replyAttachmentsAllowed: false,
      replyEnabled: false,
      replyAllEnabled: false,
      showForward: false,
      showReply: false,
      replyAll: false,
      isReply: false,
      dateTimeFormats: {
        dateFormat: defaultDateFormat,
        timeFormat: defaultTimeFormat,
      },
      showViewer: false,
      attachmentToDisplay: null,
      attachments: [],
      showModal: false,
      downloadEnabled: false,
      showDownloadDropDown: false,
      replyAlwaysEft: false
    };
  }

  componentDidMount() {
    this.getMessageDescription(this.props.messageId);
    this.getMessageOptions(this.props.messageId);
  }

  async downloadAllSeparately() {
    try {
      const attachments = this.state.message.needles.filter((needle) =>
        needle.tags.includes("attachment")
      );

      for (let i = 0; i < attachments.length; i++) {
        const { _id: needleId, filename } = attachments[i];
        await this.downloadSeparately(
          this.state.message._id,
          needleId,
          filename
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  async downloadAll() {
    try {
      const { messageId, tenantId } = this.props;

      const res = await axios({
        url: `${settings.api}/api/messages/${messageId}/token`,
        method: "get",
        headers: { tenant: tenantId },
      });

      const { token } = res.data;
      const a = document.createElement("a");
      a.href = `${settings.api}/download/${token}`;
      a.setAttribute("download", "");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    const { messageId, tenantId } = this.props;

    const {
      body,
      forwardAllowed,
      maxMailSize,
      message,
      replyAttachmentExtentions,
      replyAttachmentsAllowed,
      replyEnabled,
      replyAllEnabled,
      showForward,
      showReply,
      showViewer,
      availableUntil
    } = this.state;

    if (showReply) {
      return (
        <ComposePage
          attachmentExtentions={replyAttachmentExtentions}
          attachmentsAllowed={replyAttachmentsAllowed}
          body={body}
          maxMailSize={maxMailSize}
          message={message || {}}
          messageId={messageId}
          setShowReply={(shouldShowReply) =>
            this.setState({ showReply: shouldShowReply })
          }
          tenantId={tenantId}
          replyAll={this.state.replyAll}
          isReply={this.state.isReply}
          sender={this.state.sender}
          replyAlwaysEft={this.state.replyAlwaysEft}
        />
      );
    }

    if (showViewer) {
      return (
        <AttachmentsViewer
          setShowViewer={(shouldShowViewer) =>
            this.setState({ showViewer: shouldShowViewer })
          }
          attachment={this.state.attachmentToDisplay}
          setAttachment={(attachment) =>
            this.setState({ attachmentToDisplay: attachment })
          }
          changeDisplayedAttachment={this.changeDisplayedAttachment}
        />
      );
    }

    const {
      createdAt,
      headers = [],
      needles = [],
      recipient,
      type,
    } = message || {};
    const attachments = needles.filter((needle) =>
      needle.tags.includes("attachment")
    );

    const expiryDate = availableUntil?.split('T')?.[0]?.split('-')?.reverse()?.join('-');
    const expiryTime = availableUntil?.split('T')?.[1]?.slice(0,-8);
    const days = Math.floor((new Date(availableUntil) - new Date()) / (1000 * 60 * 60 * 24))
    const hours = Math.floor(((new Date(availableUntil) - new Date()) % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))

    return (
      <div>
        <div className={`message panel ${message ? "messageLoaded" : ""}`}>
          <div className="panelHeader">
            <h1>{translate("_secureMessage")}</h1>
          </div>
          {availableUntil && (
            <div className="expiry-banner">
              <CIcon className="fa-w-12 fa-fw mr-2" icon={cilCalendar} />
              {translate("_available_until")}:
              <span className="mx-1">{expiryDate} {expiryTime}</span>
              ({days && `${days} ${translate("_days")}`}).
            </div>
          )}
          <div className="panelContent">
            <div className="panelProps">
              <div className="row panelPropRow">
                <div className="col-sm-2 ">{translate("_from")}:</div>
                <div className="col-sm-10 ">
                  {this.state.sender?.alias
                    ? `${this.state.sender.alias} (${this.state.sender?.email})`
                    : `${this.state.sender?.email}`}
                </div>
              </div>
              <div className="row panelPropRow">
                <div className="col-sm-2 ">{translate("_to")}:</div>
                <div className="col-sm-10 ">
                  {headers
                    .filter((e) => e.name === "to")[0]
                    ?.addresses.map((e) => `${e.displayName} (${e.address})`)
                    .join(", ") || ""}
                </div>
              </div>
              {headers.filter((e) => e.name === "cc")[0] && (
                <div className="row panelPropRow">
                  <div className="col-sm-2 ">CC:</div>
                  <div className="col-sm-10 ">
                    {headers
                      .filter((e) => e.name === "cc")[0]
                      ?.addresses.map((e) => `${e.displayName} (${e.address})`)
                      .join(", ") || ""}
                  </div>
                </div>
              )}
              <div className="row panelPropRow">
                <div className="col-sm-2 ">{translate("_subject")}:</div>
                <div className="col-sm-10 ">
                  {headers.find((header) => header.name === "subject")?.value ||
                    ""}
                </div>
              </div>
              <div className="row panelPropRow">
                <div className="col-sm-2 ">{translate("_date")}:</div>
                <div className="col-sm-10 ">
                  {moment(createdAt || "").format(`${this.state.dateTimeFormats?.dateFormat || defaultDateFormat} ${this.state.dateTimeFormats?.timeFormat || defaultTimeFormat}`)}
                </div>
              </div>
            </div>
            <div className="messageContent">
              <span
                className="mailBody"
                dangerouslySetInnerHTML={{ __html: this.state.body || "" }}
              ></span>
              {/* {attachments.length > 1 ? (
                <div className="mt-3">
                  <button
                    tabIndex="0"
                    className="button"
                    title=""
                    onClick={() => this.downloadAll()}
                  >
                    <FiDownload /> {translate("message_download_all")}
                  </button>
                </div>
              ) : null} */}
              <ul className="attachments list-unstyled mt-4 py-1">
                {attachments.map((needle, i) => {
                  const { _id: needleId, hash, headers, size } = needle;
                  const contentTypeHeader = headers.find(
                    (h) => h.name === "content-type"
                  );
                  const nameParam = contentTypeHeader?.parameters?.name;
                  const isCalendar =
                    contentTypeHeader?.raw.includes("text/calendar");
                  const filename =
                    needle.filename ||
                    nameParam ||
                    (isCalendar ? "calendar.ics" : "Unknown");

                  return (
                    <li key={needleId}>
                      <Attachment
                        filename={filename}
                        hash={hash}
                        needleId={needleId}
                        onClick={() => {
                          this.downloadNeedle(message._id, needleId);
                          // this.getNeedleData(
                          //   message._id,
                          //   needleId,
                          //   filename,
                          //   i
                          // );
                          // this.setState({ showViewer: true });
                        }}
                        size={size}
                        title={translate("message_downloadNeedle", filename)}
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="messageFooter d-flex align-items-center" style={{gap: "9px"}}>
              {attachments.length > 1 ? (
                <DownloadAll
                  triggerModal={() => this.setState({ showModal: "all" })}
                  downloadZip={() => this.downloadAll()}
                />
              ) : null}
              {replyAllEnabled ? (
                <>
                  <button
                    tabIndex="0"
                    className={`reply`}
                    title={translate("message_replyAll")}
                    onClick={() =>
                      this.setState({ showReply: true, replyAll: true })
                    }
                  >
                    <FiCornerUpLeft className="" />{" "}
                    {translate("message_replyAll")}
                  </button>
                </>
              ) : null}
              {replyEnabled ? (
                <>
                  <button
                    tabIndex="0"
                    className={`reply`}
                    title={translate("message_reply")}
                    onClick={() =>
                      this.setState({ showReply: true, replyAll: false })
                    }
                  >
                    <FiCornerUpLeft className="" /> {translate("message_reply")}
                  </button>
                </>
              ) : null}
              {forwardAllowed ? (
                <button
                  tabIndex="0"
                  className={`reply`}
                  title={translate("message_forward")}
                  onClick={() => this.setState({ showForward: true })}
                >
                  <FiCornerUpRight className="" />{" "}
                  {translate("message_forward")}
                </button>
              ) : null}
            </div>
          </div>
          <div className="panelFooter">
            <div className="messageFooter d-flex align-items-center">
              {this.state.downloadEnabled && (
                <DownloadMessage 
                  handleDownload={(type) => this.downloadMessage(messageId, type)}
                  showEml={type === "eml"} 
                  showZip={attachments.length > 0} 
                />
              )}
              <button
                tabIndex="0"
                className={`button ml-auto mr-0 float-right`}
                title={translate("message_logout")}
                onClick={() => this.logout()}
              >
                {translate("message_logout")}
              </button>
            </div>
          </div>
        </div>
        {showForward ? (
          <>
            <div className="modal-backdrop fade show"></div>
            <div
              id="exampleModalLong"
              className="modal fade show"
              style={{ display: "block", paddingRight: "17px" }}
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLongTitle">
                      {translate("forward_dialogTitle")}
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => this.setState({ showForward: false })}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <p>
                      {translate("forward_dialogDescription", recipient?.email)}
                    </p>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                      onClick={() => this.setState({ showForward: false })}
                    >
                      {translate("_cancel")}
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => this.sendForward(message._id)}
                    >
                      {translate("_send")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}
        <Modal
          show={!!this.state.showModal}
          title={translate("_download_modal_title")}
          handleClose={() => this.setState({ showModal: false })}
          buttons={
            <button
              className="button"
              onClick={() => {
                if (this.state.showModal === "all")
                  this.downloadAllSeparately();
                if (this.state.showModal === "zip") this.downloadAll();
                this.setState({ showModal: false });
              }}
            >
              {translate("_confirm")}
            </button>
          }
        >
          {translate("_download_modal_body_1")} {attachments.length} {translate("_download_modal_body_2")}
        </Modal>
      </div>
    );
  }

  getMessageDescription = async (messageId) => {
    try {
      axios({
        url: `${settings.api}/api/messages/${messageId}/description`,
        method: "get",
        headers: { tenant: this.props.tenantId },
      }).then(
        (response) => {
          if (response) {

            const {
              body,
              description = {},
              forwardAllowed,
              authenticatorSource = "unknown",
              isReply = false,
              sender,
              tenantFormats
            } = response.data || {};
            const { email: username } = description.recipient || {};
            this.setState({
              message: description,
              body,
              forwardAllowed,
              isReply,
              sender,
              // dateTimeFormats: dateTimeFormats
            })
            this.props.setUser(username);
            this.props.setAuthenticatorSource(authenticatorSource);
            this.setState({ dateTimeFormats: tenantFormats })
          }
        },
        (error) => {
          this.setState({ loading: false });
          //window.location.href = `${settings.path}loginsms/${messageId}`;
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  getMessageOptions = async (messageId) => {
    try {
      const res = await axios.get(
        `${settings.api}/api/messages/${messageId}/options`,
        {
          headers: { tenant: this.props.tenantId },
        }
      );

      const { messageReply } = res.data || {};

      const {
        attachmentExtentions: replyAttachmentExtentions = [],
        attachmentsAllowed: replyAttachmentsAllowed = false,
        enabled: replyEnabled = false,
        maxMailSize,
        useAlwaysFiche: replyAlwaysEft = false
      } = messageReply || {};

      const replyAllEnabled = res.data?.messageReplyAll?.enabled || false;
      const availableUntil = res.data?.messageExpire?.date || null;
      const downloadEnabled = res.data?.messageDownload?.enabled || false;

      this.setState({
        availableUntil,
        downloadEnabled,
        maxMailSize,
        replyAllEnabled,
        replyAlwaysEft,
        replyAttachmentExtentions,
        replyAttachmentsAllowed,
        replyEnabled,
      });
    } catch (err) {
      console.log(err);
    }
  };

  downloadNeedle = async (messageId, needleId) => {
    try {
      let response = await axios({
        url: `${settings.api}/api/messages/${messageId}/needles/${needleId}/token`,
        method: "get",
        headers: { tenant: this.props.tenantId },
      });

      if (response && response.data && response.data.token) {
        const a = document.createElement("a");
        a.href = `${settings.api}/download/${response.data.token}`;
        a.setAttribute("download", "");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    } catch (err) {
      console.log(err);
    }
  };

  downloadSeparately = async (messageId, needleId, filename) => {
    try {
      const response = await axios({
        url: `${settings.api}/api/messages/${messageId}/needles/${needleId}/token`,
        method: "get",
        headers: { tenant: this.props.tenantId },
      });

      if (!response.data.token) return;
      const fileUrl = `${settings.api}/download/${response.data.token}`;
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error(`Error downloading needle ${needleId}:`, error);
    }
  }

  changeDisplayedAttachment = (i) => {
    const { message } = this.state;
    const attachments = message.needles.filter((needle) =>
      needle.tags.includes("attachment")
    );
    const needle = attachments[i];
    const { _id: needleId, filename } = needle;
    this.getNeedleData(message._id, needleId, filename, i);
  };

  getNeedleData = async (messageId, needleId, filename, i) => {
    try {
      let response = await axios({
        url: `${settings.api}/api/messages/${messageId}/needles/${needleId}/token`,
        method: "get",
        headers: { tenant: this.props.tenantId },
      });
      if (response && response.data && response.data.token) {
        const fileExt = filename.split(".").slice(-1).pop().toLowerCase();
        let image = await axios({
          url: `${settings.api}/api/messages/${messageId}/needles/${needleId}/attachment`,
          // url: `${settings.api}/api/messages/attachment/${response.data.token}`, // Problem with validating token
          method: "get",
          headers:
            // fileExt === "dcm"
            //   ? { tenant: this.props.tenantId, Accept: "image/jpeg" }
            //   : 
              { tenant: this.props.tenantId },
          responseType: 
          // fileExt === "dcm" ? "blob" : 
          "arraybuffer",
        });
        console.log("response:", image);
        if (image && image.data) {
          const blob = new Blob([image.data], {
            type: image.headers["content-type"],
          });
          const url = URL.createObjectURL(
            // fileExt === "dcm" ? image.data : 
            blob
          );
          this.setState({
            attachmentToDisplay: {
              ...{ headers: image.headers },
              ...{
                data: url,
                filename: filename,
                i: i,
                first: i === 0,
                last:
                  i ===
                  this.state.message.needles.filter((needle) =>
                    needle.tags.includes("attachment")
                  ).length -
                    1,
              },
            },
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  sendForward = async (messageId) => {
    try {
      await axios({
        url: `${settings.api}/api/messages/${messageId}/send-forward`,
        method: "post",
        headers: { tenant: this.props.tenantId },
      });

      this.setState({ showForward: false });
    } catch (err) {
      console.log(err);
    }
  };

  downloadMessage = async (messageId, type = 'eml') => {
    console.log("downloading message", { messageId });
    try {
      let response = await axios({
        url: `${settings.api}/api/messages/${messageId}/downloadlink/${type}`,
        method: "get",
        headers: { tenant: this.props.tenantId },
      });
      if (response?.data?.downloadlink) {
        const a = document.createElement("a");
        a.href = `${settings.api}${response.data.downloadlink}`;
        a.setAttribute("download", "");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    } catch (err) {
      console.log(err);
    }
  };

  logout = async () => {
    try {
      await axios({
        url: `${settings.api}/api/logout?tenant=${this.props.tenantId}`,
        method: "get",
      });
    } catch (err) {
      console.log(err);
    }
  };
}

Message.propTypes = {
  messageId: PropTypes.string.isRequired,
  tenantId: PropTypes.string.isRequired,
  setUser: PropTypes.func.isRequired,
  setAuthenticatorSource: PropTypes.func.isRequired,
};

const mapDispatchToProps = { setUser, setAuthenticatorSource };
const mapStateToProps = (state) => state.i18n;

export default connect(mapStateToProps, mapDispatchToProps)(Message);
